common.View.create('galaxy::habitats.website.partials.header.Company', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initIntroductionButton();
    },

    initIntroductionButton() {
        this.element.find('#introduction-button').on('click', (event) => {
            this.element.find('.wistia_embed img').trigger('click');
        });
    },

});